import React, { memo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import EventV2PageHead from "./V2/EventV2PageHead";

const GuardLayout = (props) => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.classList.add("dashboard-page", "event-home-page");
    return () => {
      document.body.classList.remove("dashboard-page", "event-home-page");
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  return (
    <>
      <Header />
      <main className="dash-wrap dash-v2 event-wrap event-guard-shell">
        <div className="container">
          <div className="row g-4 mt-1">
            <div className="col-12">
              <section
                className={`dash-panel event-main-panel event-guard-panel${
                  props.ExtraclassName ? ` ${props.ExtraclassName}` : ""
                }`}
                style={{ minHeight: "calc(100vh - 120px)" }}
              >
                <div className="event-main-accent" aria-hidden="true" />
                {(props.Heading || props.ButtonHeading || props.extraElement) && (
                  <EventV2PageHead
                    ButtonHeading={props.ButtonHeading}
                    Heading={props.Heading}
                    SubHeading={props.SubHeading}
                    ButtonAction={props.ButtonAction}
                    extraElement={props.extraElement}
                    BackAction={props.BackAction}
                    HeadClassName={props.HeadClassName}
                    TitleClassName={props.TitleClassName}
                    TitleMark={props.TitleMark}
                    TitleMarkClassName={props.TitleMarkClassName}
                    CreateHead={props.CreateHead}
                    DetailsHead={props.DetailsHead}
                    LeftClassName={props.LeftClassName}
                  />
                )}
                <div className="event-main-body">{props.children}</div>
              </section>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default memo(GuardLayout);
